(function ($, w, d, h, b) {

    var app = {

        initFixedHeader: function(){
            var fixed_header = $('.header-wrapper'),
                fixed_header_offset = $('.header-wrapper').height();
            $(window).on('load resize scroll orientationchange', function () {
                var scroll = $(window).scrollTop();
                if( window.innerWidth > 991 && scroll > fixed_header_offset ) {
                    fixed_header.addClass('active');
                } else {
                    fixed_header.removeClass('active');
                }
            });
        },

        initsideMenu: function() {
            $('[data-side-menu]').on('click', function () {
                var $this = $(this),
                    $sideMenu = $('.side-menu'),
                    $sideMenuOverlay = $('.side-menu-overlay'),
                    $html = $('html'),
                    option = $this.data('side-menu');
                if (option == 'open') {
                    $sideMenu.addClass('active');
                    $sideMenuOverlay.addClass('active');
                    $html.addClass('burger-menu-active');
                }
                if (option == 'close') {
                    $sideMenu.removeClass('active');
                    $sideMenuOverlay.removeClass('active');
                    $html.removeClass('burger-menu-active');
                    $('.main-nav-btn-container').removeClass('active');
                }
            });
        },

        initBikeCarousel: function() {
            $('.bike-carousel-slider').not('.slick-initialized').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 900,
                pauseOnHover: false,
                prevArrow: '.bike-carousel-controls .prev',
                nextArrow: '.bike-carousel-controls .next',
                focusOnSelect: true,
                responsive: [
                  {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
        },

        initHeaderDropdown: function() {
            $('#nav > li > a').each(function(){
                var $this = $(this);
                var $data = $this.data('title');
                var $parent = $this.parent();
                $('.main-nav-btn-container[data-title="'+$data+'"]').detach().appendTo($parent);
            });

            $('#nav li.has-sub-menu a').on('click', function (e) {
                var $this = $(this);
                var isMobile = window.matchMedia('(max-width: 991px)').matches || $('html').hasClass('mobile');
                if (isMobile) {
                    if (!$this.hasClass('clicked-once')) {
                        e.preventDefault();
                        $('#nav li.has-sub-menu a').not($this).removeClass('clicked-once');
                        $this.addClass('clicked-once');
                    }
                }
            });

            $('.sidemenu-nav > li.has-sub-menu > a').on('click', function (e) {
                var $this = $(this);
                var $data = $this.data('title');
                var isMobile = window.matchMedia('(max-width: 991px)').matches || $('html').hasClass('mobile');
                if (isMobile) {
                    if (!$this.hasClass('clicked-once')) {
                        e.preventDefault();
                        $('.sidemenu-nav > li.has-sub-menu > a').not($this).removeClass('clicked-once');
                        $('.main-nav-btn-container[data-mobile-title="'+$data+'"]').addClass('active');
                        $this.addClass('clicked-once');
                    }
                }
            });
        },

        initBikesToggle: function(){
            $('.ip-bikes-product-colors button').click(function(){
                var $this = $(this);
                var $data = $this.attr('aria-label');
                var $bike = $this.closest('.ip-bikes-product-inner').find('.bike-img');
                var $thisBike = $this.closest('.ip-bikes-product-inner').find('.bike-img[data-color="'+$data+'"]');
                $this.closest('.ip-bikes-product-colors').find('button').removeClass('active');
                $bike.removeClass('active');
                $this.addClass('active');
                $thisBike.addClass('active');
            });

            $('.ip-district-product-colors button').click(function(){
                var $this = $(this);
                var $data = $this.attr('aria-label');
                var $bike = $this.closest('.ip-district-product-inner').find('.bike-img');
                var $thisBike = $this.closest('.ip-district-product-inner').find('.bike-img[data-color="'+$data+'"]');
                $this.closest('.ip-district-product-colors').find('button').removeClass('active');
                $bike.removeClass('active');
                $this.addClass('active');
                $thisBike.addClass('active');
            });
        },

        initSmoothScroll: function(){
            function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;
            
            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');
            
                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
            };
            
            if(getUrlParameter('data-scroll')){
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $("#" + getUrlParameter('data-scroll')).offset().top - 80
                    }, 'slow');                 
                }, 500)
            }
        },

        initTargetBlank: function(){
            $('#footer-nav>li ul.sub-menu li a[data-title="Media Room"]').attr('target', '_blank');
        },

        initGlobalPopup: function(){
            $(".aios-video-popup, .aios-video-popup").magnificPopup({
                disableOn: 700,
                type: "iframe",
                removalDelay: 160,
                preloader: !1,
                fixedBgPos: !0,
                fixedContentPos: !0
            });

            $(".aios-image-popup").magnificPopup({
                type: "image",
                closeOnContentClick: !0,
                mainClass: "mfp-img-mobile",
                image: {
                    verticalFit: !0
                }
            });

            $(".aios-content-popup").magnificPopup({
                type: "inline",
                preloader: !1,
                focus: "#username",
                modal: !0,
                callbacks: {
                    open: function() {
                        var e = $(".mfp-content");
                            e.addClass("mfp-body"), 
                        $(".mfp-body").append('<button title="Close" type="button" class="mfp-close">&#215;</button>'), e.parent().append('<div class="outside-content"></div>'), $(".outside-content").on("click", function() {
                            $(this).magnificPopup("close");
                        })
                    }
                }
            });
        },

        initGlobalScroll: function(){
            var $el = $("html, body");
            $(document).on("click", ".aios-scroll-to", function(e) {
                e.preventDefault();
                var n = $(this).attr("href"),
                    i = $(this).data("offset") === undefined ? 0 : $(this).data("offset"),
                    a = $(this).data("speed") === undefined ? 1500 : $(this).data("speed");
                $el.on("scroll mousedown DOMMouseScroll mousewheel keyup", function(e) {
                    if (e.which > 0 || e.type === "mousedown" || e.type === "mousewheel") {
                        $el.stop().off("scroll mousedown DOMMouseScroll mousewheel keyup");
                    }
                });
                $("html, body").animate({
                    scrollTop: $(n).offset().top - i
                }, a);
                return false;
            });
        },

        initHashDeadlink: function(){
            $("a[href='#']").each( function(i,v) {
                $(v).addClass("aios-initial-setup-dead-link");
            });
            $("a[href='#']").click( function(e) {
                if ( $(e.currentTarget).attr("href") == "#" ) {
                    e.preventDefault();
                }
            });
        },

        initTargetBlank: function(){
            $('.footer-sitemap ul li a[href="https://app.hellosign.com/s/4gQlL8Y4"], #footer-nav>li ul.sub-menu li a[data-title="Media Room"]').attr('target', '_blank');
        },

        initEkhoLandCheckout: function(){
            $('.js-cart-toggle-trigger').on('click', function(){
                $('#ekho-land-checkout-disclaimer').show();
            });
        },

        initTriggerId: function(){
            var curUrl = $(location).attr('href');
            if(curUrl.indexOf('/pages/order-now/#disctrict-scrambler') != -1) {
                setTimeout(function() {
                   $('.ip-bo-ft-indicator-list ul li[data-content="scrambler"]').trigger('click');
                   $('.ip-bo-ft-indicator-toggle .selected-text').text('Scrambler');
                }, 1000);
            }
            if(curUrl.indexOf('/pages/order-now/#disctrict-street') != -1) {
                setTimeout(function() {
                    $('.ip-bo-ft-indicator-list ul li[data-content="street"]').trigger('click');
                    $('.ip-bo-ft-indicator-toggle .selected-text').text('Street');
                }, 1000);
            }
            if(curUrl.indexOf('/pages/order-now/#disctrict-district-street-moto-1') != -1) {
                setTimeout(function() {
                    $('.ip-bo-ft-indicator-list ul li[data-content="district-street-moto-1"]').trigger('click');
                    $('.ip-bo-ft-indicator-toggle .selected-text').text('Street Moto');
                }, 1000);
            }
        },

        initPageClass: function(){
            var curUrl = jQuery(location).attr('href');
            if(curUrl.indexOf('/pages/the-district-spare-parts-list') != -1) {
               jQuery('body').addClass('the-district-spare-parts-list');
            }
        },

        initCartCounter: function(){
                // Function to update cart counter
                function updateCartCounter () {
                $.getJSON('/cart.js', function (cart) {
                    $('#cart-counter').text(cart.item_count);
                });
                }

            
                // Call the function immediately on page load
                updateCartCounter();
            
                // Update cart counter when adding to cart
                $('.js-ajax-add').on('click', function (e) {
                    e.preventDefault();
                    const $button = $(this);
                    const form = $button.closest('form');
                    const formData = form.serialize();
            
                    $.post('/cart/add.js', formData, function () {
                        updateCartCounter(); // Update the cart counter after adding an item
                    }).fail(function () {
                        alert('Failed to add item to cart!');
                    });
                });
            
                // Update cart counter when removing items from cart
                $('.js-line-item-remove').on('click', function (e) {
                    e.preventDefault();
            
                    const $button = $(this);
                    const lineItemKey = $button.data('key'); // Get the line item key (set this as a data attribute on the button)
            
                    // Remove item from the cart
                    $.post('/cart/change.js', { id: lineItemKey, quantity: 0 }, function () {
                        updateCartCounter(); // Update the cart counter after removing an item
                    }).fail(function () {
                        alert('Failed to remove item from cart!');
                    });
                });
            
                // Update cart counter when increasing or decreasing quantities
                $('.js-quantity-decrease, .js-quantity-increase').on('click', function (e) {
                    e.preventDefault();
            
                    const $button = $(this);
                    const isIncrease = $button.hasClass('js-quantity-increase'); // Check if it's an increase or decrease button
                    const $lineItem = $button.closest('.line-item'); // Find the parent line item container
                    const lineItemKey = $lineItem.data('key'); // Get the line item key (set this as a data attribute)
                    const $quantityInput = $lineItem.find('.js-quantity-update-on-change'); // Input field for the quantity
                    let currentQuantity = parseInt($quantityInput.val()); // Get the current quantity
            
                    // Adjust quantity
                    const newQuantity = isIncrease ? currentQuantity + 1 : Math.max(0, currentQuantity - 1); // Prevent negative values
            
                    // Update the cart using /cart/change.js
                    $.post('/cart/change.js', { id: lineItemKey, quantity: newQuantity }, function (response) {
                        const updatedCart = JSON.parse(response); // Parse the updated cart response
            
                        // Update the quantity field
                        $quantityInput.val(newQuantity);
            
                        // Refresh the cart counter
                        updateCartCounter();
                    }).fail(function () {
                        alert('Failed to update cart quantity!');
                    });
                });
    
                // Refresh cart counter when clicking the cart icon (to open the cart)
                $('.nav__link-card-icon.js-cart-toggle-trigger').on('click', function () {
                    updateCartCounter(); 
                });

                $('a#cart-drawer-overlay').on('click', function () {
                    updateCartCounter(); 
                });

                $('a#cart-drawer__close').on('click', function () {
                    updateCartCounter();
                });

                /*
                setInterval(function() {
                    if (!$('body').hasClass('is-drawer-open')) {
                        setTimeout(function() {
                            updateCartCounter();  // Update cart counter
                        }, 500);  // Delay before updating the counter
                    }
                }, 1000);
                */

                if (!$('body').hasClass('is-drawer-open')) {
                    setTimeout(function() {
                        updateCartCounter();  // Update cart counter
                    }, 500);  // Delay before updating the counter
                }
        },

        initparallaxClip: function(){
            var isSafari = window.matchMedia('(max-width: 1199px)').matches;
            if(isSafari){
                if($('html').hasClass('safari-true')){
                    function trigger() {
                        $('.attachment-fixed canvas').each( function() {
                            var this_position = window.pageYOffset - $(this).offset().top;
                            $(this).css({backgroundPosition: "0 " + ( this_position * 0.3 ) + "px"})
                        });
                    }
                    trigger();
                    $(window).on('load scroll orientationchange', function () {
                        trigger();
                    });
                }
            }
        },

        initSiteAnimation: function(){
            AOS.init({
              once: true, 
              disable: 'mobile',
              duration: 1000,
            });
        }
    }

    $(document).ready( function() {
        app.initSiteAnimation();
        app.initFixedHeader();
        app.initsideMenu();
        app.initBikeCarousel();
        app.initHeaderDropdown();
        app.initBikesToggle();
        app.initSmoothScroll();
        app.initTargetBlank();
        app.initGlobalPopup();
        app.initGlobalScroll();
        app.initHashDeadlink();
        app.initTargetBlank();
        app.initEkhoLandCheckout();
        app.initTriggerId();
        app.initPageClass();
        app.initCartCounter();
        app.initparallaxClip();
    });

    var is_scrolled = false;
    $(window).on('load', function(){
        is_scrolled = true;
    });

    $(window).one('scroll mousemove touchmove', function(){
      if(!is_scrolled ) {
          AOS.refreshHard();
      }
	});

})(jQuery, window, document, 'html', 'body');

// smooth easing helper
$.easing.easeSlide = function (x, t, b, c, d) {
  return c * (1 - Math.pow(2, -10 * t / d)) + b;
};

$(document).on("click", ".sidemenu-nav .has-submenu > .menu-link", function (e) {
  e.preventDefault();

  let li = $(this).parent("li");
  let submenu = li.find("> .submenu");

  if (li.hasClass("open")) {
    li.removeClass("open");
    submenu.stop(true, true).slideUp({
      duration: 280,
      easing: "easeSlide"
    });
  } else {
    $(".sidemenu-nav .has-submenu.open").each(function () {
      $(this).removeClass("open")
        .find("> .submenu")
        .stop(true, true)
        .slideUp({
          duration: 280,
          easing: "easeSlide"
        });
    });

    li.addClass("open");
    submenu.stop(true, true).slideDown({
      duration: 280,
      easing: "easeSlide"
    });
  }
});




